import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { userOrdenCompraLst } from 'src/app/models/userLst';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-index-detalle-orden-compra-admin',
  templateUrl: './index-detalle-orden-compra-admin.component.html',
  styleUrls: ['./index-detalle-orden-compra-admin.component.scss'],
})
export class IndexDetalleOrdenCompraAdminComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  public saldo: number = 0;
  public valOrdenTmp: number = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public disciplinaSvc: DisciplinaService,
    public ordenCompraSvc: OrdenCompraService,
    private alertify: AlertifyService,
    private empresaSvc: EmpresaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<IndexDetalleOrdenCompraAdminComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: userOrdenCompraLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'plan',
      'fechaHasta',
      'estadoDetalle',
    ];

    this.dataSource = new MatTableDataSource<userOrdenCompraLst>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    //  this.getListadoHorarios(0, 10);

    console.log('datos e ingreso son: ', this.dataInput);
    this.calcularValorOrden();
  }

  ngAfterViewInit() {
    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
      this.getUsers(0, 10);
    });

    this.empresaSvc
      .getSaldoEmpresaAdmin(this.dataInput)
      .subscribe((saldoEmp) => {
        this.saldo = saldoEmp;
      });
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistasPorOrdenCompraActivos(
        page,
        numReg,
        this.searchString,
        this.dataInput,
        this.disciplinaSelect
      )
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<userOrdenCompraLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getUsers(this.pageIndex, this.pageSize);
  }

  cambioEstadoDetalle(obj: userOrdenCompraLst, evento: any) {
    console.log(evento);
    console.log(obj);

    this.ordenCompraSvc
      .cambiaEstadoDetalleUsuarioEstadoOrden(obj.detalleOrdenId, evento)
      .subscribe((result) => {
        if (result) {
          //   elemento.estado = ob.checked;

          this.calcularValorOrden();
        } else {
          console.log('error al cambiar de estado');
        }
      });
  }

  calcularValorOrden() {
    this.ordenCompraSvc.getValorOrdenCompraAdmin(this.dataInput).subscribe(
      (valOC) => {
        console.log('el valor de la OC es: ', valOC);
        this.valOrdenTmp = valOC;
      },
      (err) => {
        this.valOrdenTmp = 0;
      }
    );
  }

  rechazar(obj: any): void {
    this.alertify.confirm('Confirma el rechazo de la orden de compra?', () => {
      this.ordenCompraSvc.rechazarOrdenCompra(obj.id).subscribe((result) => {
        if (result) {
          this.getUsers(this.pageIndex, this.pageSize);
          this.alertify.success('Orden de compra rechazada');
        } else {
          this.alertify.error('La orden de compra no se puede rechazar');
        }
      });
    });
  }
}
